import * as ActionTypes from './RestaurantsActionTypes';
import { IRestaurant } from './IRestaurant';
import { TRestaurantSectionAdapt } from '../../types/IRestaurantTablesSchemaStore';

/** @description Экшен для отправки запроса на получение залов */
export function getSections(
  restaurantId: number,
): IRestaurant {
  return {
    type: ActionTypes.GET_SECTION_REQUEST,
    payload: {
      restaurantId,
    },
  };
}

/** @description Экшен для обработки успешного запроса на получение столов */
export function getSectionSuccess(sections: Array<TRestaurantSectionAdapt>): IRestaurant {
  return {
    type: ActionTypes.GET_SECTION_REQUEST_SUCCESS,
    payload: {
      sections,
    },
  };
}

/** @description Экшен для обработки ошибки запроса на получение столов */
export function getSectionError(): IRestaurant {
  return {
    type: ActionTypes.GET_SECTION_REQUEST_ERROR,
    error: 'Не удалось получить список залов',
  };
}
